// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1974a96c] .list-group-item.list_title a:focus{border:.1em solid #fff;-webkit-box-shadow:0 0 0 .1em #000 inset;box-shadow:inset 0 0 0 .1em #000;border-radius:.25em;padding:.1em .2em}", ""]);
// Exports
module.exports = exports;
